import { render, staticRenderFns } from "./Counselling.vue?vue&type=template&id=3435be02&"
import script from "./Counselling.vue?vue&type=script&lang=js&"
export * from "./Counselling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports